import { useEffect, useState } from 'react';
import { useWebsocket } from '../components/socketContext/socketContext';
import { subscribeApiSocket } from '../api/socket';
import { fetchLineHistory, getSubscriptionId } from '../api/api';
import { useQueryClient, useQuery } from 'react-query'
import RouteUtils from '../utils/routeUtils'
import _ from 'lodash';
export const useLineHistoryQuery = (league, gameId, marketFilter, sportsBook) => {
    const [history, setHistory] = useState();
    const queryClient = useQueryClient();
    const socket = useWebsocket();

    const leagueFilter = RouteUtils.getLeague(league);

    const query = useQuery([gameId, marketFilter, sportsBook],
        () => fetchLineHistory(gameId, marketFilter, sportsBook), {
        retry: (count, { message: status }) => (status !== '404' && status !== '401' && status !== '500'),
    });

    const handleSocketMessage = async (m) => {
        let data = JSON.parse(m.data);
        if (!data || !data.id) {
            console.warn(`Socket ignoring unexpected message: ${JSON.stringify(data)}`);
            return;
        }
        queryClient.setQueryData([league, gameId], data);
        setHistory((h) => {
            if (!h?.length)
                return h
            const newLine = [...h];
            const oldLine = h.findIndex(g => g.recorded_datetime === data.recorded_datetime);
            if (oldLine !== -1) {
                newLine[oldLine].markets = data.markets;
            } else {
                newLine.push({ markets: data.markets, recorded_datetime: data.recorded_datetime });
            }
            return newLine;
        })
    }

    const handleSocketOpen = () => {
        if (data) {
            subscribeApiSocket(socket, [getSubscriptionId(leagueFilter, data.map((g, id) => getSubscriptionId(leagueFilter, `${g.recorded_datetime}.${id}`)))]);
        }
    }

    const { isLoading, data, isError } = query;

    useEffect(() => {
        socket.addEventListener('message', handleSocketMessage);
        socket.addEventListener('open', handleSocketOpen);

        return () => {
            socket.removeEventListener('message', handleSocketMessage);
            socket.removeEventListener('open', handleSocketOpen)
        }
    }, [isLoading]);

    useEffect(() => {
        setHistory(data);

        queryClient.setQueryData([league, gameId], data);
        if (data && data.length > 0) {
            subscribeApiSocket(socket, data.map((game, index) => getSubscriptionId(leagueFilter, `${game.recorded_datetime}.${index}.`)));
        }
    }, [data])

    return { isLoading, history, isError };
}